import {
  ITEM_TEMPLATE_ALL, ITEM_TEMPLATE_GET, ITEM_TEMPLATE_PUT, ITEM_TEMPLATE_DEL, ITEM_TEMPLATE_POST,
  ITEM_TEMPLATE_RESET, ITEM_TEMPLATE_LOADING, ITEM_TEMPLATE_ERROR,
} from '../../actions/types';

const initialState = {
  rows: [],
  total: 0,
  isLoading: false,
  isCompleted: true,
};

export default function ItemTemplateReducer(state = initialState, action) {
  switch (action.type) {
    case ITEM_TEMPLATE_ALL:
      return { ...action.payload, isLoading: false, isCompleted: true };
    case ITEM_TEMPLATE_GET:
      return { ...state, ...action.payload, isLoading: false, isCompleted: true };
    case ITEM_TEMPLATE_POST:
    case ITEM_TEMPLATE_PUT:
    case ITEM_TEMPLATE_DEL:
      return { ...state, isLoading: false, isCompleted: true };
    case ITEM_TEMPLATE_RESET:
      return { ...initialState };
    case ITEM_TEMPLATE_LOADING:
      return { ...state, isLoading: true, isCompleted: true };
    case ITEM_TEMPLATE_ERROR:
      return { ...state, isLoading: false, isCompleted: false };
    default:
      return state;
  }
}
